import React from "react"

import { useTranslation } from "gatsby-plugin-react-i18next"

import DeskopCard from "./desktopCard"
import ResponsiveCard from "./responsiveCard"
export default ({ material, date, price, img, percentage, currency, unit }) => {
  const { t } = useTranslation()

  return (
    <div
      className={`
      w-full`}
    >
      <div
        className={`
            hidden
            desk:block`}
      >
        <DeskopCard
          material={material}
          date={date}
          price={price}
          img={img}
          percentage={percentage}
          currency={currency}
          unit={unit}
        />
      </div>
      <div
        className={`
            w-full
            desk:hidden`}
      >
        <ResponsiveCard
          material={material}
          date={date}
          price={price}
          img={img}
          percentage={percentage}
          currency={currency}
          unit={unit}
        />
      </div>
    </div>
  )
}
